export default __webpack_public_path__ + "static/media/left-arrow-blue-small.9cf6be24.svg";